import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

/**
 * @param {string} teId
 * @param {{ signal?: AbortSignal }} [opts]
 */
export async function fetchTeChronoRecords(teId, opts = {}) {
  if (!teId) return null;
  try {
    const resp = await fetch(
      `${ip_back}api/TE/${encodeURIComponent(teId)}/chrono-records`,
      { method: "GET", headers: authHeaders(), signal: opts.signal }
    );
    const json = await resp.json().catch(() => ({}));
    if (!resp.ok || !json?.status) return null;
    return json.data || null;
  } catch (err) {
    if (err?.name === "AbortError") throw err;
    return null;
  }
}

/**
 * @param {string} teId
 * @param {{
 *   userId?: string|null,
 *   playerId?: string|null,
 *   timeSec: number,
 *   videoUrl?: string|null,
 *   videoMessageId?: string|null,
 *   videoStartMs?: number|null,
 *   videoEndMs?: number|null,
 *   startedAt?: string|null,
 *   stoppedAt?: string|null,
 *   videoEpochAt?: string|null,
 * }} payload
 */
export async function saveTeChronoRecord(teId, payload) {
  if (!teId) throw new Error("te_id required");
  const resp = await fetch(
    `${ip_back}api/TE/${encodeURIComponent(teId)}/chrono-records`,
    {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        user_id: payload.userId || null,
        player_id: payload.playerId || null,
        time_sec: payload.timeSec,
        video_url: payload.videoUrl ?? null,
        video_message_id: payload.videoMessageId ?? null,
        video_start_ms: payload.videoStartMs ?? null,
        video_end_ms: payload.videoEndMs ?? null,
        started_at: payload.startedAt ?? null,
        stopped_at: payload.stoppedAt ?? null,
        video_epoch_at: payload.videoEpochAt ?? null,
      }),
    }
  );
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || !json?.status) {
    const err = new Error(json?.message || "Failed to save chrono record");
    err.code = json?.code || null;
    throw err;
  }
  return json.data || null;
}

/**
 * @param {string} teId
 * @param {{ userId?: string|null, playerId?: string|null }} payload
 */
export async function deleteTeChronoRecord(teId, payload) {
  if (!teId) throw new Error("te_id required");
  const resp = await fetch(
    `${ip_back}api/TE/${encodeURIComponent(teId)}/chrono-records`,
    {
      method: "DELETE",
      headers: authHeaders(),
      body: JSON.stringify({
        user_id: payload.userId || null,
        player_id: payload.playerId || null,
      }),
    }
  );
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || !json?.status) {
    const err = new Error(json?.message || "Failed to delete chrono record");
    err.code = json?.code || null;
    throw err;
  }
  return json.data || null;
}
